import Styled from "styled-components";

export const ActTagViewForPcGrid = Styled.section`
    width: 100%;
	display: flex;
	overflow: hidden;
	padding: 1px 0;
	> img {
		height: 16px;
		min-width: 86px;
		margin-right: 6px;
	}
	> img:last-child {
		margin-right: 0;
	}
`;
